const SoundManagerEvent = {};

SoundManagerEvent.AUDIO_PAUSED = "AUDIO_PAUSED";
SoundManagerEvent.AUDIO_CUE_CHANGED = "AUDIO_CUE_CHANGED";
SoundManagerEvent.AUDIO_ENDED = "AUDIO_ENDED";

export default SoundManagerEvent;